import { grey, text } from '../colors';

export const muiTableCell = {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${grey[100]}`,
      padding: '12px 16px',
    },
    head: {
      borderBottom: `1px solid ${grey[200]}`,
      color: text.secondary,
    },
  },
};
